import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useSetPasswordMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useSetPassword = () => {
  const [handle, { data, loading, error: apolloError }] =
    useSetPasswordMutation();

  const error = useError(apolloError);

  return {
    data,
    loading,
    error,
    setPassword: useCallback(
      async (newPassword: string) => {
        const res = await handle({
          variables: { input: { newPassword } },
        });
        return res.data?.setPassword;
      },
      [handle]
    ),
  };
};
